import { createSlice } from "@reduxjs/toolkit";
import { getAssessment } from "../../builders/exam-assessment/start-assessment.builder";

const initialState = {
    isAssessmentInformationFilled: false,
    isAssessmnetInformationNextClicked: true,
    loading: false,
    assessment: [],
    module: [],
    topic: [],
    assessmentData: []
}

const assessmentSlice = createSlice({
    name:'assessment',
    initialState,
    reducers:{
        resultInformationFilled: (state,action) => {
            state.isAssessmentInformationFilled = action.payload
        },
        resultInformationNextClicked: (state, action) => {
            state.isAssessmnetInformationNextClicked = action.payload
        },
        clearExtraReducers : (state) => {
            state.loading = false,
            state.assessment = [],
            state.module = [],
            state.topic = [],
            state.assessmentData = []
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAssessment.pending, (state)=>{
            state.loading = true,
            state.assessment = []
        }),
        builder.addCase(getAssessment.fulfilled, (state, action)=>{
            state.loading = false
            state.assessment = action.payload
        }),
        builder.addCase(getAssessment.rejected, (state)=>{
            state.loading = false
        })
    }
})

export const { assessmentInformationFilled } = assessmentSlice.actions

export default assessmentSlice.reducer;